



















































import { defineComponent, onMounted, ref } from '@vue/composition-api';
import WeeklyChallengeCreateForm from '@/bundles/ActivityGroup/components/WeeklyChallengeCreateForm.vue';
import WeeklyChallengeEditForm from '@/bundles/ActivityGroup/components/WeeklyChallengeEditForm.vue';
import { useWeeklyChallenge } from '@/bundles/ActivityGroup/composables/useWeeklyChallenge';

export default defineComponent({
  components: {
    WeeklyChallengeCreateForm,
    WeeklyChallengeEditForm,
  },
  setup() {
    const {weeklyChallenges, loading, fetchWeeklyChallenges} = useWeeklyChallenge();
    const showCreateDialog = ref(false);
    const showEditDialog = ref(false);
    const selectedChallenge = ref(null);

    const headers = [
      {text: 'Name', value: 'name', sortable: false},
      {text: 'Image', value: 'image', sortable: false},
      {text: 'Summary', value: 'summary', sortable: false},
      {text: 'Actions', value: 'actions', sortable: false},
    ];

    onMounted(() => {
      fetchWeeklyChallenges();
    });

    function editChallenge(challenge: any) {
      selectedChallenge.value = challenge;
      showEditDialog.value = true;
    }

    function refreshList() {
      fetchWeeklyChallenges();
      showCreateDialog.value = false;
      showEditDialog.value = false;
    }

    function closeDialog() {
      showCreateDialog.value = false;
      showEditDialog.value = false;
      selectedChallenge.value = null;
    }

    return {
      headers,
      weeklyChallenges,
      loading,
      showCreateDialog,
      showEditDialog,
      selectedChallenge,
      editChallenge,
      refreshList,
      closeDialog,
    };
  },
});
